import React from 'react'
import ExperienceCard from '../components/ExperienceCard'
import '../style/style.css'
import {motion} from 'framer-motion'

export default function Experience() {
    return (
      <motion.div 
        initial={{opacity:0, y:"-100%"}} 
        animate={{opacity:1, y:0}} 
        exit={{opacity:0, y:"-100%"}} 
        transition={{type:"spring"}}
        className="col-lg-9 col-md-9 col-sm-9 col-xs-12">
        <div className="container" style={{overflowY:'scroll' , overflowX:'hidden'}}>
          <h1>Experience</h1>  
            <ExperienceCard /> 
        </div>
      </motion.div>
    )
}
